module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "pgepubid00002"
    }
  }, [_c('h2', {
    staticClass: "nobreak"
  }, [_vm._v("LIST OF ILLUSTRATIONS")])]), _vm._v(" "), _c('table', {
    staticClass: "calibre13",
    attrs: {
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre14"
  }, [_c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("A frolic would follow")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0002#Page_0"
    }
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Frontispiece")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "tdr",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "allsmcap"
  }, [_vm._v("FACING"), _c('br', {
    staticClass: "calibre9"
  }), _vm._v("\nPAGE")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Most unpromising she was, at the first glance")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005#Page_6"
    }
  }, [_vm._v("      6")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("She fled with him down the aisle")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011#Page_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      84")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre15"
  }, [_c('td', {
    staticClass: "calibre16"
  }, [_vm._v("Van caught up with Piggy at the far end of the lawn")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016#Page_152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      152")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0